/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here. Focal is extensible through JavaScript
 * events and custom elements.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * Fired when a variant is added through a form selector (product page, quick view...). It does NOT cover changes
 * made to an existing line in the cart; for that see cart:updated.
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart;
 * });
 *
 * NOTE, LEARNED THE HARD WAY: this does NOT fire on every path. A quantity change on the cart page re-renders
 * the section without emitting it, which is why syn-freeship.js also runs a MutationObserver.
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Drawers and popovers take an "open" attribute. To open the cart drawer:
 *
 * document.getElementById('mini-cart').open = true;
 *
 * To build your own drawer, re-use <drawer-content>:
 *
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 * <drawer-content id="id-of-drawer">Your content</drawer-content>
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * "vendor.js": custom-elements polyfill (v1.0.0), web-animations-polyfill (v2.3.2), instant-page (v5.1.0),
 * tocca (v2.0.9), seamless-scroll-polyfill (v2.0.0).
 * "flickity.js" v2.2.0 and "photoswipe" v4.1.3 load on demand only.
 */

/* ----------------------------------------------------------------------------
 * SYNERGY loader, 2026-08-18.
 *
 * Loads Synergy's own assets, so layout/theme.liquid never has to be touched.
 * The asset URL is derived from this script's own src, because a .js file
 * cannot use Liquid filters.
 *
 * TWO FILES WE CANNOT EDIT FROM HERE, AND ALMOST EVERY WORKAROUND BELOW EXISTS
 * BECAUSE OF THEM:
 *   snippets/synergy-product-kit.liquid  230,953 bytes, ~19x the write ceiling.
 *       Emits the inline product page script and stylesheet, including the free
 *       shipping progress bar, the threshold CONFETTI, and the
 *       content-visibility rules on the below-the-fold sections.
 *   assets/syn-lineup.js                 23,452 bytes, past the ceiling.
 *       Owns the .syn-cardlink full-card overlay, a syn-tilt TRANSFORM on each
 *       card, WILL-CHANGE: TRANSFORM on each card, and a display:none rule
 *       that paints out quick view site wide.
 *
 *   syn-lineup.js    product tiles, stars, trust strip, mobile row lift.
 *   syn-diff.js      the "How We're Different" band, plus the homepage category
 *                    grid fix at mid widths
 *   syn-usa.js       American made: badge, cart line, footer link, ", USA"
 *                    wherever the site says Miami, and stripping the "Textured
 *                    Black" chip off PRx resale cards. THE SVG WIDTH AND HEIGHT
 *                    ATTRIBUTES IN THAT FILE ARE LOAD-BEARING: without them the
 *                    flag renders at 300x150 until its stylesheet arrives.
 *   syn-freeship.js  THE FREE SHIPPING THRESHOLD, and the ONLY place that knows
 *                    it. SINGLE CONSTANT, THRESHOLD_CENTS, AT THE TOP, plus a
 *                    MODE of 'threshold' | 'all' | 'off'. It rewrites the
 *                    threshold copy baked into 76 templates, keeps the kit's
 *                    progress bar hidden, and renders the cart notice itself.
 *                    It rewrites the threshold copy baked into 76 templates
 *                    and renders the cart and drawer notice. The KIT'S product
 *                    page bar is visible again as of v68 and is correct: kit
 *                    v2.84 counts Synergy-made lines only, by VENDOR, so the
 *                    bar, the notice and the confetti agree. Only the THEME'S
 *                    own bar stays hidden, because it reads the theme setting
 *                    and counts PRx.
 *   syn-cartadd.js   "+ Add to cart" on the recommendation cards inside
 *                    #mini-cart, THE CART DRAWER ONLY.
 *   syn-quickview.js quick view ON COLLECTION TILES. SEVEN things were stopping
 *                    it and each hid the next. See
 *                    cro/cart-shipping-card-2026-08-18.md.
 *   syn-shiftlog.js  DIAGNOSTIC, OFF UNLESS THE URL CARRIES ?synshift. Records
 *                    sub-pixel layout shifts with the ancestor path of every
 *                    source, for the intermittent product page "vibration".
 *                    Run synShiftReport() in the console. DELETE THIS FILE AND
 *                    ITS LOADER ENTRY once that is settled.
 *
 * NOT LOADED: assets/syn-grain.js, assets/syn-hero.js and the stray
 * assets/syn-freeship-version.txt. All three are orphans kept only because the
 * delete API is blocked for agents. Remove them in Edit code when convenient.
 *
 * CACHE BUSTING. `bust` IS SHARED BY EVERY FILE BELOW, so BUMP IT BY HAND
 * WHENEVER ANY OF THEM CHANGES. If you forget, returning visitors keep the old
 * file and the change looks like it did nothing. Shopify's asset_url token
 * cannot be reused: it is per file, so it would not change when a sibling does.
 *
 * A brand new duplicate serves fresh URLs, so the first edit after duplicating
 * needs no bump; but the moment ANY page of that theme has loaded once, the CDN
 * has cached its assets and every later in-place edit is stale again. IF A
 * DEPLOYED CHANGE SEEMS ABSENT, FETCH THE SERVED FILE AND GREP IT FIRST.
 *
 * v43 to v49: syn-freeship.js. Free shipping on every order, the asterisk and
 *      PRx exclusion, the duplicate-notice fix, live cart updates, and the
 *      saving stated at every cart size.
 * v50 to v53: syn-cartadd.js. ONE white card in the cart's own Montserrat type
 *      system; buttons pinned to the foot of the card; the 2px hover lift
 *      dropped; suppression moved to a stylesheet rule.
 * v54: syn-quickview stops setting position on the quick form. Plus
 *      syn-freeship v9, which stops the shipping card rendering INSIDE a
 *      collection product tile.
 * v55: THE CART PAGE IS REVERTED. syn-cartadd is scoped to #mini-cart alone.
 * v56 to v59: the collection quick view chain. z-index trapped in the image
 *      wrapper's stacking context, the syn-tilt transform, will-change, then
 *      the panel's z-index trapped inside an isolation:isolate card.
 * v60: syn-cartadd hides button.product-item__link, which is what the DRAWER
 *      uses; there are zero .product-item__quick-form elements in #mini-cart.
 * v61 and v62: the quick view panel reappeared card-anchored and behind the
 *      tiles WHILE CLOSING. The lift is released by a requestAnimationFrame
 *      poll, because transitionend BUBBLES and fires early from children.
 * v63: syn-freeship v10. PRx is decided by the cart line's VENDOR.
 * v64: syn-freeship v11. The threshold CONFETTI is blocked by parking a hidden
 *      element on the id its own re-entrancy guard checks for.
 * v65: syn-usa v7. The giant flag flash: a viewBox with no width or height
 *      renders at the 300x150 SVG default until the stylesheet arrives.
 * v66: syn-shiftlog.js added, gated on ?synshift. The "vibration" is
 *      intermittent, so it is recorded rather than hunted (2026-08-18).
 * v67: syn-freeship v12. THE $249 THRESHOLD (2026-09-15). Chris: "now we want
 *      to introduce a free shipping threshold of orders over $249 get free
 *      shipping." FREE_SHIP_ALL became MODE, the number lives in
 *      THRESHOLD_CENTS alone, and the copy sweep now rewrites every historical
 *      threshold string ($599, $699, $999, $1,299) to the current one rather
 *      than to "On every order". THE DOLLAR SIGN IN THAT PATTERN IS
 *      LOAD-BEARING: without it the sweep also rewrote "Order over 1000 lb
 *      capacity", a spec line on the rack pages, into a shipping threshold.
 * v68: syn-freeship v13 + kit v2.84. THE PRODUCT PAGE PROGRESS BAR AND THE
 *      CONFETTI ARE BACK, on Chris's word. Neither could just be switched on:
 *      the kit's bar measured cart.total_price, the WHOLE cart, and PRx items
 *      never ship free, so a PRx-only cart would have filled the bar, claimed
 *      "Your order ships free" and fired the confetti for an order checkout
 *      then charges shipping on. Fixed at source in the kit, which now counts
 *      Synergy-made lines only by VENDOR. Bar, cart notice and confetti all
 *      read the same number. The THEME'S own free-shipping-bar stays hidden.
 * -------------------------------------------------------------------------- */
(function () {
  var self = document.currentScript || document.querySelector('script[src*="custom.js"]');
  if (!self || !self.src) return;
  var bust = 'v68';
  var base = self.src.split('?')[0];
  ['syn-lineup.js', 'syn-diff.js', 'syn-usa.js', 'syn-freeship.js',
   'syn-cartadd.js', 'syn-quickview.js', 'syn-shiftlog.js'].forEach(function (name) {
    var el = document.createElement('script');
    el.src = base.replace('custom.js', name) + '?v=' + bust;
    el.defer = true;
    document.head.appendChild(el);
  });
})();
